import React from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { Button } from 'primereact/button'
import { useAuth } from '../../Authentication'
import logo from '../../../static/BSC Logos.png'
import './DashboardLayout.css'

interface NavItem {
  label: string
  icon: string
  path: string
}

const navItems: NavItem[] = [
  { label: 'Visão Geral', icon: 'pi pi-home', path: '/dashboard' },
  { label: 'Clientes', icon: 'pi pi-users', path: '/dashboard/clientes' },
  { label: 'Aplicativos', icon: 'pi pi-desktop', path: '/dashboard/aplicativos' },
  { label: 'Contratos', icon: 'pi pi-file', path: '/dashboard/contratos' },
  { label: 'Assinaturas', icon: 'pi pi-credit-card', path: '/dashboard/assinaturas' },
]

interface DashboardLayoutProps {
  children: React.ReactNode
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  return (
    <div className='dashboard-shell'>
      <aside className='dashboard-sidebar'>
        <div className='sidebar-logo' onClick={() => navigate('/dashboard')}>
          <img src={logo} alt='BSC Tecnologia' height={36} />
        </div>

        <nav className='sidebar-nav'>
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === '/dashboard'}
              className={({ isActive }) =>
                `sidebar-nav-item ${isActive ? 'active' : ''}`
              }
            >
              <i className={item.icon} />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className='sidebar-footer'>
          <div className='sidebar-user'>
            <i className='pi pi-user' />
            <span>{user?.name ?? 'Usuário'}</span>
          </div>
          <Button
            icon='pi pi-sign-out'
            tooltip='Sair'
            tooltipOptions={{ position: 'right' }}
            text
            severity='secondary'
            onClick={logout}
            className='logout-btn'
          />
        </div>
      </aside>

      <main className='dashboard-content'>{children}</main>
    </div>
  )
}

export default DashboardLayout
